import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=18fd0c90&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=18fd0c90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fd0c90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18fd0c90')) {
      api.createRecord('18fd0c90', component.options)
    } else {
      api.reload('18fd0c90', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=18fd0c90&scoped=true&", function () {
      api.rerender('18fd0c90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/n8n/Index.vue"
export default component.exports